'use client';

import cn from 'classnames';
import Link from 'next/link';

interface ConfidentialityNoticeProps {
	testId?: string;
	classNames?: string;
}

const ConfidentialityNotice = (props: ConfidentialityNoticeProps) => {
	const { testId = 'ConfidentialityNotice', classNames } = props;

	return (
		<div
			data-testid={testId}
			className={cn(
				'text-balance text-center text-sm font-normal text-slate-500',
				classNames,
			)}
		>
			<div>
				By submitting this form, you agree that HVAC.com may share your
				information with independent, authorized HVAC dealers in your area. You
				also consent to being contacted by phone, text, or email by HVAC.com and
				these dealers, which may include the use of automated technology. Your
				consent is not a condition of purchase. Message and data rates may
				apply. You may opt out at any time. For more information, please review
				our{' '}
				<Link
					href="/privacy-policy"
					className="text-sky-700 hover:text-sky-800 hover:underline"
				>
					Privacy Policy
				</Link>{' '}
				and{' '}
				<Link
					href="/terms-of-use"
					className="text-sky-700 hover:text-sky-800 hover:underline"
				>
					Terms of Service
				</Link>
				. HVAC.com is not an HVAC service provider and does not guarantee dealer
				pricing, availability, or service quality. Dealer participation may vary
				by location.
			</div>
		</div>
	);
};

export default ConfidentialityNotice;
